import ReactMarkdown from "react-markdown";

export default function Markdown({ children }) {
  return (
    <div data-testid="markdown">
      <ReactMarkdown
        components={{
          h1: (p) => <h1 className="font-serif text-2xl text-foreground mt-5 mb-2" {...p} />,
          h2: (p) => <h2 className="font-serif text-xl text-foreground mt-6 mb-2" {...p} />,
          h3: (p) => <h3 className="font-medium text-foreground mt-4 mb-1" {...p} />,
          p: (p) => <p className="text-sm text-foreground/80 leading-relaxed mb-3" {...p} />,
          ul: (p) => <ul className="list-disc pl-5 space-y-1 mb-3 text-sm text-foreground/80" {...p} />,
          ol: (p) => <ol className="list-decimal pl-5 space-y-1 mb-3 text-sm text-foreground/80" {...p} />,
          li: (p) => <li className="leading-relaxed" {...p} />,
          strong: (p) => <strong className="font-semibold text-foreground" {...p} />,
          em: (p) => <em className="italic" {...p} />,
          a: (p) => <a className="text-foreground underline underline-offset-2" {...p} />,
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
